/* @flow */

import * as React from 'react';

import { type Ingredient, ingredientIcon } from '../domain/pizza';

type Props = {
  ingredient: ?Ingredient,
  selected?: boolean,
};

export const PizzaIngredientIcon = ({ ingredient, selected }: Props) => {
  const classes = ['pizza-icon', 'primary100-color'];
  if (selected) classes.push('selected');
  if (ingredient) {
    return <img className={classes.join(' ')} src={ingredientIcon(ingredient)} />;
  } else {
    classes.push('pizza-icon--dummy');
    return <div className={classes.join(' ')} />;
  }
};
